<template>  
  <v-container fluid grid-list-lg class="ma-0 pa-0">
    <v-card flat>
      <v-card-text>
        <v-layout row>
          <v-flex xs12 md6>
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.nomor"
              label="Pertanyaan"
              :items="pertanyaans"
              item-text="name"        
              item-value="id"                    
              :loading="pertanyaanLoading"
              autocomplete="off"
            />
          </v-flex>          
          <v-flex xs12 md6>
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.nomors"
              label="Disilangkan dengan Pertanyaan"
              :items="pertanyaans"
              item-text="name"        
              item-value="id"      
              multiple
              :loading="pertanyaanLoading"
              autocomplete="off"
            />
          </v-flex>          
        </v-layout> 
        <v-layout row>
          <v-flex xs6 md3 lg2 v-if="!disabled.addr_idkab">
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idpro"
              label="Provinsi"
              :items="provinsi"
              item-text="name"
              item-value="id"
              :loading="provinsiLoading"
              :disabled="disabled.addr_idpro"
              clearable
              autocomplete="off"
              multiple
            />
          </v-flex>
          <v-flex xs6 md3 lg2>  
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idkab"
              label="Kabupaten/Kota"
              :items="kabupaten"
              item-text="name"
              item-value="id"
              :loading="kabupatenLoading"
              :disabled="disabled.addr_idkab"
              clearable autocomplete="off"
              multiple
            />
          </v-flex>
          <v-flex xs6 md3 lg2>  
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idkec"
              label="Kecamatan"
              :items="kecamatan"
              item-text="name"
              item-value="id"
              :loading="kecamatanLoading"
              :disabled="disabled.addr_idkec"
              clearable autocomplete="off"
              multiple
            />
          </v-flex>
          <v-flex xs6 md3 lg2>  
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idkel"
              label="Kelurahan"
              :items="kelurahan"
              item-text="name"
              item-value="id"
              :loading="kelurahanLoading"
              :disabled="disabled.addr_idkel"
              clearable autocomplete="off"
              multiple
            />
          </v-flex>  
          <!--<v-flex xs6 md3 lg2>                   
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.tps_id"
              label="TPS"
              :items="tps"
              item-text="name"
              item-value="id"
              :loading="tpsLoading"
              clearable autocomplete="off"
            />
          </v-flex>-->          
        </v-layout>       
      </v-card-text>
      <v-divider />
      <v-card-text>
        <v-layout row>
          <v-flex xs12 md6 v-for="(item, i) in charts" :key="i">
            <v-card>                  
              <template v-if="!item.loading">
                <v-card-text class="v-data-table__wrapper pa-0 mb-3" :id="'export'+i" style="position:relative; overflow:auto">
                  <v-btn color="success" dark @click="export2excel(i)" small style="position:absolute; right:2px; top:2px">
                    <v-icon left>select_all</v-icon>.xls
                  </v-btn>
                  <table class="tb-normal" style="width:100%">
                    <thead class="white--text" :style="'background:'+(item.color?item.color:'#000')">
                      <tr>
                        <th rowspan="2">No.</th>
                        <th rowspan="2">
                          {{pertanyaans.find(x=>x.no==fm.nomor)?pertanyaans.find(x=>x.no==fm.nomor).question:'Keterangan'}}
                        </th>
                        <th class="text-left" :colspan="item.columns.length">{{item.question}}</th>
                      </tr>
                      <tr>
                        <th v-for="(column, i) in item.columns" :key="i">{{column.text}}</th>
                      </tr>                    
                    </thead>
                    <tbody>
                      <tr v-for="(data, i) in item.data" :key="i">
                        <td>{{i+1}}</td>
                        <td>{{data.value}}</td>                      
                        <template v-for="(child, j) in data.childs">
                          <td :key="j" class="text-right">{{child.persen}}%</td>                                                  
                          <!--<td :key="'persen'+j" class="text-right">{{child.people}}</td>-->                        
                        </template>                      
                      </tr>
                    </tbody>
                    <tfoot v-if="item.data.length <= 0">
                      <tr><th colspan="3">No Data Result</th></tr>
                    </tfoot>
                  </table>
                </v-card-text>
                <echart :option="item.chartOption" :height="item.height? item.height+'px':'390px'" />
              </template> 
              <template v-else>
                <v-skeleton-loader                
                  style="width:100%"
                  type="card, article"
                ></v-skeleton-loader>
              </template>
            </v-card>             
          </v-flex>          
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Table2Excel  from 'table2excel.js';  
import Echart from '@/app/components/other/echart';
import { debounce } from 'lodash'
import Model from '@/app/models/Report'
const  model = new Model()

export default {
  components:{Echart},
  props:{
    jilid : {type:Object}
  },
  data () {
    return {
      fm:{ nomor:1, nomors:[], addr_idpro:null, addr_idkab: null, addr_idkec:null, addr_idkel:null },    
      disabled : {addr_idpro : false, addr_idkab: false, addr_idkec: false, addr_idkel:false},
      provinsi  : [], kabupaten : [], kecamatan : [], kelurahan : [], tps:[],
      provinsiLoading  : false, kabupatenLoading : false, kecamatanLoading : false, kelurahanLoading : false, tpsLoading:false,
      firstime : true,

      charts : [],
      pertanyaans  : [], pertanyaanLoading  : false, 
      loading : false,
      chartOption :  {
        title: {
            text: '',
            subtext: ''
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },        
        legend: {
            data: []
        },
        toolbox: {
            show : true,
            x: 'right',
            feature : {
                mark : {show: true},
                //dataView : {show: true, readOnly: false},
                //restore : {show: true},
                saveAsImage : {show: true, title:'Pict'}
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
        },
        yAxis: {
            type: 'category',
            data: ['巴西','印尼','美国','印度','中国','世界人口(万)']
        },
        series: [           
        ]
      },
    }
  },
  computed:{
        
  },
  watch:{
    'fm.nomors'(newIds) {
      if(Array.isArray(this.jilid.quetionnaires)){
        this.charts = [];
        newIds.forEach(id=>{        
          let q = this.jilid.quetionnaires.find(x=>x.no==id);
          if(q){
            this.charts.push({no:q.no, type:q.type, question:q.question, loading:true, color:'black', option:q.option, chartOption:{}, data:[], columns:[],  height:390});        
          }          
        })
      }        
    },
    'fm': {
      handler : debounce(function () {     
        if(this.firstime){
          if(this.fm.addr_idpro || this.fm.addr_idkab || this.fm.addr_idkec || this.fm.addr_idkel){
            this.firstime = false
            this.readItems()
          }          
        } else {
          this.readItems()
        }        
      }, 2500), 
      deep:true,
    },    
    'fm.addr_idpro':debounce(function (newId) {
      if(newId && newId[0]){
        newId = newId[0]      
        model.node({id:newId,jilid_id:this.jilid.id}).then(res=>{this.provinsi.push(res)});
        this.kabupatenLoading = true; //this.fm.addr_idkab = null;
        model.kabupaten({parent:newId,jilid_id:this.jilid.id}).then(data=>{
          this.kabupaten=data; this.kabupatenLoading = false;  
          this.fm.addr_idkab = this.fm.addr_idkab && data.find(x=>x.id === this.fm.addr_idkab) ? this.fm.addr_idkab : null;         
        })
      } else {
        this.fm.addr_idkab = null; this.kabupaten = []; 
        this.fm.addr_idkec = null; this.kecamatan = []; 
        this.fm.addr_idkel = null; this.kelurahan = []; 
      }
    }, 2000),
    'fm.addr_idkab':debounce(function (newId) {
      if(newId && newId[0]){ 
        newId = newId[0]     
        this.kecamatanLoading = true;
        model.kecamatan({parent:newId,jilid_id:this.jilid.id}).then(data=>{
          this.kecamatan=data; this.kecamatanLoading = false;
          this.fm.addr_idkec = this.fm.addr_idkec && data.find(x=>x.id===this.fm.addr_idkec) ? this.fm.addr_idkec:null;
          if(this.kecamatan.find(x=>x.id===this.fm.addr_idkec)){
            this.fm.addr_postcode = this.fm.addr_postcode ? this.fm.addr_postcode:this.kecamatan.find(x=>x.id===this.fm.addr_idkec).kodepos;
          }  
        })        
      } else {
        this.fm.addr_idkec = null; this.kecamatan = []; 
        this.fm.addr_idkel = null; this.kelurahan = [];         
      }
    }, 2000),
    'fm.addr_idkec':debounce(function (newId) {
      if(newId && newId[0]){ 
        newId = newId[0]     
        this.kelurahanLoading = true; 
        model.kelurahan({parent:newId,jilid_id:this.jilid.id}).then(data=>{
          this.kelurahan=data; this.kelurahanLoading = false;
          this.fm.addr_idkel = this.fm.addr_idkel && data.find(x=>x.id===this.fm.addr_idkel) ? this.fm.addr_idkel : null;           
        })      
        if(this.kecamatan.find(x=>x.id===newId)){
          let kodepos = this.kecamatan.find(x=>x.id===newId).kodepos;
          this.fm.addr_postcode = this.fm.addr_postcode ? this.fm.addr_postcode : kodepos; 
        }  
      } else {
        this.fm.addr_idkel = null; this.kelurahan = [];
      }
    }, 2000),  
    'fm.addr_idkel':debounce(function (newId) {
      if(newId && newId[0]){      
        newId = newId[0]
        if(newId){
          this.tpsLoading = true;
          model.node({id:newId,jilid_id:this.jilid.id}).then(data=>{
            this.kelurahan.push(data); 
            model.tps({idkel:data.id}).then(res=>{
              this.tps = res.data;
              this.tpsLoading = false;
            })
          })  
        } else if(this.kelurahan.find(x=>x.id===newId)){
          this.tpsLoading = true;
          model.tps({idkel:newId}).then(res=>{
            this.tps = res.data;
            this.tpsLoading = false;
          })
        }
      } 
    }, 2000),
  },  
  mounted() {
    this.loading = true;
    this.init();
  },
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    init(){      
      if(this.jilid.node_id){
        model.node({id:this.jilid.node_id,jilid_id:this.jilid.id}).then(res=>{
          if(res.level){
            this.disabled.addr_idpro = false;
            this.disabled.addr_idkab = false;
            this.disabled.addr_idkec = false;
            this.disabled.addr_idkel = false;
            this.fm.addr_idpro = null;
            this.fm.addr_idkab = null;
            this.fm.addr_idkec = null;
            this.fm.addr_idkel = null;
            switch(parseInt(res.level)){
              case 1: this.fm.addr_idpro = [res.id]; 
                this.disabled.addr_idpro = true;
                break;
              case 2: this.fm.addr_idkab = [res.id]; 
                this.disabled.addr_idpro = true;
                this.disabled.addr_idkab = true;
                break;
              case 3: this.fm.addr_idkec = [res.id]; 
                this.disabled.addr_idpro = true;
                this.disabled.addr_idkab = true;
                this.disabled.addr_idkec = true;
                break;
              case 4: this.fm.addr_idkel = [res.id]; 
                this.disabled.addr_idpro = true;
                this.disabled.addr_idkab = true;
                this.disabled.addr_idkec = true;
                this.disabled.addr_idkel = true;
                break;
            }
          }            
        })
      }
      if(Array.isArray(this.jilid.quetionnaires)){
        let no = 0;
        this.jilid.quetionnaires.forEach(q=>{
          this.pertanyaans.push({id:q.no, name:q.no+'. '+q.question, loading:true,option:{}});
          if(q.no !== this.fm.nomor && no <4){
            this.fm.nomors.push(q.no);
            no++;
          }                              
        })
      }
    },

    readItems () {
      if(Array.isArray(this.charts)){
        this.charts.forEach(c=>{
          c.loading = true;    
          const params = {        
            jilid_id: this.jilid.id,        
            no: this.fm.nomor,
            noto: c.no,
            idpro:this.fm.addr_idpro,
            idkab:this.fm.addr_idkab,
            idkec:this.fm.addr_idkec,
            idkel:this.fm.addr_idkel,
            expand:'quetionnaires'
          }

          model.silang(params).then(data => {            
            c.columns = [];                  
            if(Array.isArray(data) && Array.isArray(c.option)){
              let columns = [];
              if(c.type == 3){
                data.forEach(item=>{
                  if(Array.isArray(item.child)){
                    item.child.forEach(child => {
                      if(!columns.includes(child.answer)){
                        columns.push(child.answer)                      
                      }
                    })
                  }
                });
              } else {
                c.option.forEach(opt=>{
                  columns.push(opt.id)
                })
              }                

              c.height = (data.length*columns.length*20) > 390 ? (data.length*columns.length*20) : 390;
              c.chartOption = JSON.parse(JSON.stringify(this.chartOption));  
              c.chartOption.legend.data = [];  
              c.chartOption.yAxis.data = [];            
              c.chartOption.series     = [];
              columns.forEach(column=>{
                let opt = c.option.find(x=>x.id==column);
                if(c.type==3){
                  c.columns.push({id:column, text:opt?opt.key:column});
                  c.chartOption.legend.data.push(opt?opt.key:column);                                    
                  c.chartOption.series.push({name: opt?opt.key:column,type: 'bar',label: {normal: {show: true,position: 'right',formatter: "{c}%"}},data: []});                                     
                } else {                  
                  c.columns.push({id:column, text:opt?opt.value:column});                  
                  c.chartOption.legend.data.push(opt?opt.value:column);                                    
                  c.chartOption.series.push({name: opt?opt.value:column,type: 'bar',label: {normal: {show: true,position: 'right',formatter: "{c}%"}},data: []});                                     
                }                                          
              })
              data.forEach(item=>{       
                item.childs = [];        
                c.chartOption.yAxis.data.push(item.value);                 
                if(Array.isArray(item.child)){
                  let subtotal = 0;
                  item.child.forEach(chl=>{
                    subtotal += parseInt(chl.people);
                  })
                  columns.forEach((column,i)=>{
                    let dat = item.child.find(x=>x.answer==column);
                    if(dat){
                      let persen = parseFloat(parseInt(dat.people)/parseInt(subtotal)*100).toFixed(1);
                      item.childs.push({people: dat.people, answer : dat.answer, persen:persen});
                      c.chartOption.series[i].data.push(persen);
                    } else {
                      item.childs.push({people: 0, answer : null, persen:0});
                      c.chartOption.series[i].data.push(0);
                    }
                  });
                }               
              });              
              c.data  = data;              
              c.color = this.$color() || '#000'; 
            }
            c.loading = false
          })
        })
      }            
    },      

    export2excel(i){
      var filename = 'Report.'+i+'.';
      filename    += this.$moment().format('DDMMYY.HHmm');
      new Table2Excel('#export'+i+' table',{
        plugins: [{
          workcellCreated ({ workbook, tables, worksheet, table, workcell, cell, cellStyle, rowRange, colRange }) {
            workcell.style = {
              ...workcell.style,
              font: {},
              color: '#000'
            }
          }
        }]
      }).export(filename);
    },
  },  
}
</script>